module.exports = __webpack_public_path__ + "img/leida.940d7ee7.svg";